import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { AsideDefault } from "../../../_metronic/layout/components/aside/AsideDefault";
import { PageDataProvider, useLayout } from "../../../_metronic/layout/core";
import { useLocation } from "react-router-dom";
import { ActivityDrawer, ThemeModeProvider } from "../../../_metronic/partials";
import { DrawerComponent, MenuComponent } from "../../../_metronic/assets/ts/components";
import { Toolbar } from "./Toolbar";
import clsx from "clsx";
import { LicenseManager } from "ag-grid-enterprise";

const DEFAULT_CONTENT_CLASSES = ["post", "d-flex", "flex-column-fluid"];

LicenseManager.setLicenseKey(process.env.REACT_APP_DIGITENT_AGGRID_LICENSE || "");
const MainLayout = () => {
    const { classes, isGrid } = useLayout();
    const location = useLocation();

    const [contentClasses, setContentClasses] = useState<string[]>(DEFAULT_CONTENT_CLASSES);
    const [containerClasses, setContainerClasses] = useState<string[]>(classes.contentContainer);

    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization();
        }, 500);
    }, []);

    useEffect(() => {
        setTimeout(() => {
            MenuComponent.reinitialization();
        }, 500);
    }, [location.key]);

    useEffect(() => {
        DrawerComponent.hideAll();
    }, [location]);

    useEffect(() => {
        if (isGrid) {
            setContentClasses([...DEFAULT_CONTENT_CLASSES, "content-grid"]);
            setContainerClasses([...classes.contentContainer, "container-grid"]);
        } else {
            setContentClasses(DEFAULT_CONTENT_CLASSES);
            setContainerClasses(classes.contentContainer);
        }
    }, [isGrid]);

    return (
        <PageDataProvider>
            <ThemeModeProvider>
                <div className="page d-flex flex-row flex-column-fluid">
                    <AsideDefault />
                    <div className="wrapper d-flex flex-column flex-row-fluid" id="kt_wrapper">
                        <div id="kt_content" className={contentClasses.join(" ")}>
                            <Toolbar />

                            <div className="post d-flex flex-column-fluid" id="kt_post">
                                <div
                                    id="kt_content_container"
                                    className={clsx(containerClasses.join(" "))}
                                >
                                    <Outlet />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* begin:: Drawers */}
                <ActivityDrawer />
                {/* end:: Drawers */}
            </ThemeModeProvider>
        </PageDataProvider>
    );
};

export { MainLayout };
